import React from 'react';
import AddEditPlanForm from 'ui-component/addEditPlanForm';
import AddEditRoleForm from 'ui-component/AddEditRoleForm';

function AddPlan() {
  return (
    <div>
      <AddEditPlanForm title="Add Plan" />
    </div>
  );
}

export default AddPlan;
